import toast from "react-hot-toast";

/** An error toast that never stacks: the same message replaces itself instead of piling up (1NOW-11215). */
export const toastOnce = (message: string) => toast.error(message, { id: message });
